module.exports = __webpack_public_path__ + "img/welfare_bg.f04ffbe0.jpg";